export default "__VITE_ASSET__CK9kinFK__"